import { Glyph } from '@/components/icons';
import { cn } from '@/lib/utils';
import type { Strings } from '@/str';

interface VerdictBlockProps {
  pickedCorrect: boolean;
  t: Strings;
  onShowExplain: () => void;
}

export function VerdictBlock({ pickedCorrect, t, onShowExplain }: VerdictBlockProps) {
  return (
    <div
      role="status"
      data-verdict
      className={cn(
        'flex items-start justify-between gap-3 border-t-2 pt-3',
        pickedCorrect ? 'border-t-ok' : 'border-t-bad',
      )}
    >
      <div className="min-w-0">
        <div
          className={cn(
            'text-t13 font-extrabold tracking-[0.04em] uppercase',
            pickedCorrect ? 'text-ok' : 'text-bad',
          )}
        >
          {pickedCorrect ? t.correct : t.wrong}
        </div>
        {!pickedCorrect && <div className="text-t12 text-faint mt-1 text-pretty">{t.added}</div>}
      </div>
      <LearnButton t={t} onClick={onShowExplain} />
    </div>
  );
}

export function LearnButton({
  t,
  onClick,
  quiet = false,
}: {
  t: Strings;
  onClick: () => void;
  quiet?: boolean;
}) {
  return (
    <button
      type="button"
      data-learn
      data-quiet={quiet || undefined}
      className="flex min-h-11 flex-none items-center p-0 active:scale-[0.96]"
      onClick={onClick}
    >
      <span className="text-t14 relative flex min-h-10 items-center gap-2 overflow-hidden rounded-sm bg-[#ffd400] px-3.5 font-extrabold text-[#16181c] shadow-[0_4px_12px_rgba(255,212,0,0.26)]">
        {!quiet && (
          <span
            aria-hidden
            className="animate-cta-sweep pointer-events-none absolute inset-y-0 -left-[70%] w-3/5 bg-[linear-gradient(100deg,rgba(255,255,255,0)_0%,rgba(255,255,255,0.72)_50%,rgba(255,255,255,0)_100%)] [animation-delay:1s]"
          />
        )}
        <Glyph name="book" size={16} weight={2.3} className="relative flex-none" />
        <span className="relative">{t.explainLink}</span>
        <span
          aria-hidden
          className={cn(
            'relative inline-block',
            !quiet && 'animate-cta-nudge [animation-delay:0.8s]',
          )}
        >
          →
        </span>
      </span>
    </button>
  );
}
